import React from "react";
import styled from "styled-components";

const Card = ({ Icon, desc, title, detail, number }) => (
  <Container>
    <CardTop aria-hidden="true"><Icon /><span>{number}</span></CardTop>
    <h3>{title}</h3>
    <p>{desc}</p>
    <Detail>{detail}</Detail>
  </Container>
);

export default Card;

const Container = styled.article`
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  border: 1px solid rgba(190, 224, 204, 0.16);
  border-radius: 1.25rem;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.055), rgba(255, 255, 255, 0.015));
  transition: border-color 200ms ease, background-color 200ms ease;

  @media (hover: hover) {
    &:hover {
      border-color: rgba(166, 217, 188, 0.45);
      background-color: rgba(255, 255, 255, 0.025);
    }
  }

  h3 {
    margin-top: 1.5rem;
    color: #f2f7f4;
    font-size: 1.05rem;
    font-weight: 500;
    letter-spacing: -0.025em;
    line-height: 1.45;
  }

  p {
    margin-block: 0.85rem 1.5rem;
    color: #c1d2c9;
    font-size: 0.8rem;
    line-height: 1.85;
  }

  @media (prefers-reduced-motion: reduce) { transition: none; }
`;

const CardTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #a6d9bc;

  svg { width: 1.4rem; height: 1.4rem; }
  span { color: #9ebbaa; font-size: 0.7rem; letter-spacing: 0.08em; }
`;

const Detail = styled.div`
  margin-top: auto;
  padding-top: 1rem;
  border-top: 1px solid rgba(190, 224, 204, 0.13);
  color: #a6d9bc;
  font-size: 0.65rem;
  line-height: 1.8;
`;
